import { computed, makeAutoObservable, observable } from 'mobx';
import { RootStore } from './RootStore';
import { TGetAllAvailablePrizesResponse } from '@daymade/api-contracts';

export class AllPrizesPageStore {
  root: RootStore;
  matchingPrizes: TGetAllAvailablePrizesResponse = [];
  lastCriteria: AllPrizesPageCriteria | undefined;
  totalMatchingPrizes: number = 0;
  isFallbackPrizes = false;
  cursor: string | undefined;

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this, {
      matchingPrizes: observable,
      lastCriteria: observable,
      totalMatchingPrizes: observable,
      cursor: observable,
    });
  }

  setMatchingPrizes = (
    criteria: AllPrizesPageCriteria,
    matchingPrizes: TGetAllAvailablePrizesResponse,
    totalMatchingPrizes: number,
    cursor: string | undefined,
    isFallbackPrizes: boolean,
  ) => {
    this.lastCriteria = criteria;
    this.matchingPrizes = matchingPrizes;
    this.totalMatchingPrizes = totalMatchingPrizes;
    this.cursor = cursor;
    this.isFallbackPrizes = isFallbackPrizes;
  };

  getIsFallbackPrizes = (criteria: AllPrizesPageCriteria) => {
    if (criteriaMatches(this.lastCriteria, criteria)) {
      return this.isFallbackPrizes;
    }
    return [];
  };

  getMatchingPrizes = (criteria: AllPrizesPageCriteria) => {
    if (criteriaMatches(this.lastCriteria, criteria)) {
      return this.matchingPrizes;
    }
    return [];
  };

  getTotalMatchingPrizes = (criteria: AllPrizesPageCriteria) => {
    if (criteriaMatches(this.lastCriteria, criteria)) {
      return this.totalMatchingPrizes;
    }
    return 0;
  };

  getCursor = (criteria: AllPrizesPageCriteria) => {
    if (criteriaMatches(this.lastCriteria, criteria)) {
      return this.cursor;
    }
    return undefined;
  };
}

function criteriaMatches(
  x: AllPrizesPageCriteria | undefined,
  y: AllPrizesPageCriteria | undefined,
) {
  if (!x || !y) {
    return false;
  }
  return Object.keys(x).every(
    (key) =>
      x[key as keyof AllPrizesPageCriteria] ===
      y[key as keyof AllPrizesPageCriteria],
  );
}

export interface AllPrizesPageCriteria {
  term?: string | undefined;
  category?: string | undefined;
  tier?: string | undefined;
}
